export default {
  button: {
    p: 0,
    '&:hover': {
      opacity: 0.8,
    },
  },
};
